import * as DIVISION_TYPES from './actionTypes';
import { DivisionActions, IDivisionState } from './types';

export const initialState: IDivisionState = {
  divisionList: [],
  total: 0,
  loading: false,
  error: null
};

const divisionReducer = (state = initialState, action = {} as DivisionActions): IDivisionState => {
  switch (action.type) {
    case DIVISION_TYPES.FETCH_DIVISION_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case DIVISION_TYPES.FETCH_DIVISION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        divisionList: action.payload.divisionList,
        total: action.payload.total,
        error: null
      };
    case DIVISION_TYPES.FETCH_DIVISION_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case DIVISION_TYPES.CLEAR_DIVISION_LIST:
      return {
        ...state,
        divisionList: [],
        total: 0,
        error: null
      };
    default:
      return state;
  }
};

export default divisionReducer;
